/**
 * Vuex-mutations
 */
export default {
  setSaveUser(state, user) {
    state.user = user
  },
  setSaveCartCount(state, count) {
    state.count = count
  },
  setSaveHeadTitle(state, headtitle) {
    state.headtitle = headtitle
  },
  setSaveFootActive(state, footactive) {
    state.footactive = footactive
  },
  setSaveLoading(state, LOADING) {
    state.LOADING = LOADING
  },
  showLoading(state) {
    state.LOADING = true
  },
  hideLoading(state) {
    state.LOADING = false
  },
  setSaveHeadActive(state, headactive) {
    state.headactive = headactive
  },
  setSaveSportsId(state, sportsId) {
    state.sportsId = sportsId
  },
  setSaveActiveTab(state, activeTab) {
    state.activeTab = activeTab
  },
  setSaveSideActive(state, sideactive) {
    state.sideactive = sideactive
  },
  setSaveColor(state, color) {
    state.color = color
  },
  setGamesInfo(state, value) {
    state.gamesInfo = value
  },
}
